import { lazy } from "react";
// Logos
import { AiFillHome, AiOutlineFlag, AiOutlineUser } from "react-icons/ai";
import { MdHotel, MdLocalAirport, MdOutlineEmail } from "react-icons/md";
import { BiMoney } from "react-icons/bi";
import { HiOutlineOfficeBuilding } from "react-icons/hi";
// Screens
const HomeScreen = lazy(() => import("screens/Dashboard/HomeScreen"));
const CircuitsScreen = lazy(() => import("screens/Dashboard/Circuits"));
const AirlinesScreen = lazy(() => import("screens/Dashboard/Airlines"));
const HotelsScreen = lazy(() => import("screens/Dashboard/Hotels"));
const QuotationsScreen = lazy(() => import("screens/Dashboard/Quotations"));
const AdminsScreen = lazy(() => import("screens/Dashboard/Admins"));
const PromotionsScreen = lazy(() => import("screens/Dashboard/Promotions"));
const EditProfile = lazy(() => import("screens/Dashboard/EditProfile"));
const OfficeBranchesScreen = lazy(() =>
  import("screens/Dashboard/OfficeBranches/")
);
const ConfigScreen = lazy(() => import("screens/Dashboard/Config/"));
const RatesScreen = lazy(() => import("screens/Dashboard/Rates"));
const Notifications = lazy(() => import("screens/Dashboard/Notifications"));
export const routes = [
  {
    path: "/dashboard/",
    pathWithoutParams: "/dashboard",
    exact: true,
    component: HomeScreen,
    label: "Inicio",
    icon: <AiFillHome />,
    onlyAdmin: false,
    sidebar: true,
  },
  {
    path: "/dashboard/circuitos/:screen?/:id?/",
    pathWithoutParams: "/dashboard/circuitos/",
    exact: true,
    component: CircuitsScreen,
    label: "Circuitos",
    icon: <AiOutlineFlag />,
    onlyAdmin: true,
    sidebar: true,
  },
  {
    path: "/dashboard/aerolineas/:screen?/:id?/",
    pathWithoutParams: "/dashboard/aerolineas/",
    exact: true,
    component: AirlinesScreen,
    label: "Aerolineas",
    icon: <MdLocalAirport />,
    onlyAdmin: true,
    sidebar: true,
  },
  {
    path: "/dashboard/hoteles/:screen?/:id?/",
    pathWithoutParams: "/dashboard/hoteles/",
    exact: true,
    component: HotelsScreen,
    label: "Hoteles",
    icon: <MdHotel />,
    onlyAdmin: true,
    sidebar: true,
  },
  {
    path: "/dashboard/cotizaciones/:screen?/:id?/",
    pathWithoutParams: "/dashboard/cotizaciones/",
    exact: true,
    component: QuotationsScreen,
    label: "Cotizaciones",
    icon: <MdOutlineEmail />,
    onlyAdmin: false,
    sidebar: true,
  },
  {
    path: "/dashboard/administradores/:screen?/:id?/",
    pathWithoutParams: "/dashboard/administradores/",
    exact: true,
    component: AdminsScreen,
    label: "Admins",
    icon: <AiOutlineUser />,
    onlyAdmin: true,
    sidebar: true,
  },
  {
    path: "/dashboard/promociones/:screen?/:id?/",
    pathWithoutParams: "/dashboard/promociones/",
    exact: true,
    component: PromotionsScreen,
    label: "Promociones",
    icon: <BiMoney />,
    onlyAdmin: true,
    sidebar: true,
  },
  {
    path: "/dashboard/sucursales/:screen?/:id?/",
    pathWithoutParams: "/dashboard/sucursales/",
    exact: true,
    component: OfficeBranchesScreen,
    label: "Sucursales",
    icon: <HiOutlineOfficeBuilding />,
    onlyAdmin: true,
    sidebar: true,
  },
  {
    path: "/dashboard/tarifas/:screen?/:id?/",
    pathWithoutParams: "/dashboard/tarifas/",
    exact: true,
    component: RatesScreen,
    label: "Tarifas",
    icon: <BiMoney />,
    onlyAdmin: true,
    sidebar: true,
  },
  {
    path: "/dashboard/editar-perfil/",
    pathWithoutParams: "/dashboard/editar-perfil",
    exact: true,
    component: EditProfile,
    label: "Editar perfil",
    icon: <AiOutlineUser />,
    onlyAdmin: false,
    sidebar: false,
  },
  {
    path: "/dashboard/notificaciones/",
    pathWithoutParams: "/dashboard/notificaciones",
    exact: true,
    component: Notifications,
    label: "Notificaciones",
    icon: null,
    onlyAdmin: false,
    sidebar: false,
  },
  {
    path: "/dashboard/configuracion/",
    pathWithoutParams: "/dashboard/configuracion",
    exact: true,
    component: ConfigScreen,
    label: "Configuración",
    icon: null,
    onlyAdmin: true,
    sidebar: false,
  },
];
